import { DealAssistantAuthError, DealAssistantDealerMissingError, DealAssistantTimeoutError } from '../agent/dealAssistantFetch';
import type { DealAssistantFailureDetails } from '../monitoring/dealAssistantMonitoring';

const CODE_PATTERN = /^[a-z][a-z_]{0,63}$/;

const isHttpStatus = (value: unknown): value is number =>
    Number.isInteger(value) && (value as number) >= 100 && (value as number) <= 599;

export const toFailureDetails = (error: unknown): DealAssistantFailureDetails => {
    if (error instanceof DealAssistantTimeoutError) {
        return { code: 'timeout' };
    }
    if (error instanceof DealAssistantDealerMissingError) {
        return { code: 'dealer_missing' };
    }
    if (error instanceof DealAssistantAuthError) {
        return { code: 'auth', ...(error.cause instanceof Error && { causeName: error.cause.name }) };
    }
    const { status, payload } = (error ?? {}) as { status?: unknown; payload?: { message?: unknown } };
    if (isHttpStatus(status)) {
        const message = payload?.message;
        return { code: typeof message === 'string' && CODE_PATTERN.test(message) ? message : `http_${status}`, httpStatus: status };
    }
    if ((error as { name?: unknown } | null | undefined)?.name === 'AbortError') {
        return { code: 'aborted' };
    }
    if (error instanceof TypeError) {
        return { code: 'network_error' };
    }
    return { code: 'client_error' };
};
